import React from "react";
import AdminRankUpgrades from "./AdminRankUpgrades";

export default function AdminDigitalEducationLedger() {
  return (
    <AdminRankUpgrades
      title="Ledger: Digital Education Prime / Rank Upgrades"
      defaultStatus="SUCCESS"
      readOnly
    />
  );
}
